import optional from '@nullvoxpopuli/ember-composable-helpers/helpers/optional';
import { t } from 'ember-intl';
import BvSelect from 'volta/components/bv-select';

import type { TOC } from '@ember/component/template-only';
import type { SafeString } from '@ember/template';
import type { ComponentLike } from '@glint/template';
import type { TButtonSize } from 'volta/components/bv-btn';
import type { BvSelectArgs } from 'volta/components/bv-select';
import type { TDateField } from 'volta/models/types/planning-order';

interface PoWorkbenchDateViewSelectSignature {
  Args: {
    disabled?: boolean;
    fill?: boolean;
    inline?: boolean | undefined;
    isLoading?: boolean;
    label?: string | SafeString | undefined;
    onChange?: BvSelectArgs['onChange'];
    selectedDateField: unknown;
    size?: TButtonSize | undefined;
    triggerComponent?: ComponentLike<any>;
  };
  Element: HTMLElement;
  Blocks: {
    default: [TDateField];
  };
}

const Options = ['reorderDate', 'launchDate', 'deliveryDate', 'dueDate'];

const PoWorkbenchDateViewSelectComponent: TOC<PoWorkbenchDateViewSelectSignature> = <template>
  <BvSelect
    @labelInline={{@inline}}
    @label={{@label}}
    @selected={{@selectedDateField}}
    @onChange={{optional @onChange}}
    @options={{Options}}
    @matchTriggerWidth={{false}}
    @fill={{@fill}}
    @iconLeft='calendar-outline'
    @isLoading={{@isLoading}}
    @disabled={{@disabled}}
    @size={{@size}}
    @triggerComponent={{@triggerComponent}}
    ...attributes
    as |option|
  >
    {{#if (has-block)}}
      {{yield option}}
    {{else if option}}
      {{t option}}
    {{/if}}
  </BvSelect>
</template>;

export default PoWorkbenchDateViewSelectComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'PoWorkbench::DateViewSelect': typeof PoWorkbenchDateViewSelectComponent;
    'po-workbench/date-view-select': typeof PoWorkbenchDateViewSelectComponent;
  }
}
